import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import {makeStyles} from '@mui/styles'
import {useCallback, useMemo} from 'react';
import { Fade } from '@mui/material';

const useStyles = makeStyles({
  menuImage: {
    position: 'fixed',
    left: 65,
    top: 0,
    width: 235,
    height: 130,
    backgroundSize: 'cover',
    backgroundColor: 'white',
    borderRight: '1px solid #CCC',
    borderBottom: '1px solid #DDD',
  },
  menuDashboardLink: {
    paddingTop: 25,
    paddingLeft: 15,
  },
  menuDashboardLinkMobileBar: {
    position: 'absolute',
    right: 0,
  }
});

const MobileMenu = ({data}) => {

  const activeNids = [];
  const findActiveNids = (bookLinks) => {
    {
      // Add all main ids.
      bookLinks.map((item) => {
        if (item.active && item.nid) {
          activeNids.push(item.nid);
        }

        // If there are items nested, check them too.
        if (item.children) {
          item.children.map((item) => {
            if (item.active && item.nid) {
              if (activeNids.indexOf(item.nid) === -1) {
                activeNids.push(item.nid);
              }
            }

            if (item.children) {
              findActiveNids(item.children);
            }
          });
        }
      });
    }
  }

  const classes = useStyles()
  const navigate = useNavigate()
  const menuData = JSON.parse(data.page_index)

  // Get active nids.
  const activeMainItems = menuData.book_links.filter(e => e.active && e.active === true);
  findActiveNids(activeMainItems);

  const [selected, setSelected] = React.useState(false)
  const [activeMenu, setActiveMenu] = React.useState(activeNids);

  const handleMenuClick = useCallback((e, path) => {
    e.stopPropagation();
    navigate(path)
  }, [navigate])

  const handleMenuToggle = () => {
    setSelected(!selected)
  }

  const handleMenuItemToggle = useCallback((e, key) => {
    if (e) {
      e.stopPropagation();
    }

    const newMenuStates = [...activeMenu];
    const index = newMenuStates.indexOf(key);

    if (index < 0) {
      newMenuStates.push(key);
    } else {
      newMenuStates.splice(index, 1);
    }

    setActiveMenu(newMenuStates);
  }, [activeMenu])

  const menu = useMemo(() => {
    const generateSubMenu = (subMenuData, parentNid, depth) => {
      const rows = []
      let submenu = []
      let active = false
      let has_children = false

      for (const childKey in subMenuData) {
        if (Object.hasOwn(subMenuData, childKey)) {
          submenu = []
          active = false
          has_children = false
          if (Object.keys(subMenuData[childKey].children).length > 0) {
            submenu.push(generateSubMenu(subMenuData[childKey].children, subMenuData[childKey].nid, depth + 1))
            has_children = true
          }

          if (activeMenu.includes(subMenuData[childKey].nid) === true) {
            active = true
          }

          const color_theme = subMenuData[childKey].theme;

          rows.push(
            <li className={`list-group-item-sub ${color_theme} py-2 ${active === true ? 'active' : ''} ${has_children ? 'has_children' : ''}`} key={subMenuData[childKey].nid} onClick={(e) => handleMenuItemToggle(e, subMenuData[childKey].nid)}>
              <a className={`${active === true ? 'active' : ''}`} onClick={(e) => handleMenuClick(e, subMenuData[childKey].url)} href={subMenuData[childKey].url}>{subMenuData[childKey].title}</a>
              {submenu.length> 0 ? <Fade in={active}><div className={`subsubmenu-container ${active ? 'active' : ''}`}>
                {submenu}
              </div></Fade>:(null)}
            </li>
          )
        }
      }

      return (
        <ul className="list-group flex-column d-inline-block submenu" key={`submenu-${parentNid}`}>
          {rows}
        </ul>
      )
    }

    const rows = []
    const depth = 1
    let children = []
    let has_children = false
    let active = false;

    for (const key in menuData.book_links) {
      if (Object.hasOwn(menuData.book_links, key)) {
        children = []
        has_children = false

        if (Object.keys(menuData.book_links[key].children).length > 0) {
          children.push(generateSubMenu(menuData.book_links[key].children, menuData.book_links[key].nid, depth))
          has_children = true
        }

        if (activeMenu.includes(menuData.book_links[key].nid) === true) {
          active = true
        } else {
          active = false
        }

        const color_theme = menuData.book_links[key].theme;

        rows.push(
          <li className={`main-menu-item ${color_theme} py-2 ${active === true ? 'active' : ''} ${has_children ? 'has_children' : ''}`} key={menuData.book_links[key].nid} onClick={(e) => handleMenuItemToggle(e, menuData.book_links[key].nid)}>
            <a href={menuData.book_links[key].url} className={`${active === true ? 'active' : ''}`} >
              <span className="ml-2">{menuData.book_links[key].title}</span>
            </a>

            {children.length> 0 ? <Fade in={active}><div className={`submenu-container ${active === true ? 'active' : ''}`}>
              {children}
            </div></Fade>:(null)}

          </li>
        )
      }
    }

    return rows
  }, [activeMenu, menuData, handleMenuClick, handleMenuItemToggle])

  return (
    <>
      <div className={'ou-hamburger'} onClick={handleMenuToggle}>
        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-bq05nv-MuiSvgIcon-root" focusable="false"
             aria-hidden="true" viewBox="0 0 24 24" data-testid="SubjectIcon">
          <path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"></path>
        </svg>
        <a className={classes.menuDashboardLinkMobileBar} href="/user">Terug naar dashboard</a>
      </div>

      {selected ? <Fade in={selected}>
        <div className="ou-mobile-menu">
          <div className={'close'} onClick={handleMenuToggle}>
            <svg xmlns="http://www.w3.org/2000/svg" height="30px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="30px">
              <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"/>
            </svg>
          </div>
          <ol className="list-group flex-column d-inline-block menu" key="mobile-menu">
            {menu}
          </ol>
        </div>
      </Fade> : null}
    </>
  )
}

export default MobileMenu;
